import React from 'react'
import Title from '../../ui/title/Title'

function NotFoundPage() {
  return (
    <main>
      <Title text={'404'}/>
      <Title text={'Not Found'}/>
    </main>
  )
}

export default NotFoundPage